__turbopack_context__.v({
  "container": "errorBoundary-module-scss-module__a-MpIW__container",
  "message": "errorBoundary-module-scss-module__a-MpIW__message",
  "section": "errorBoundary-module-scss-module__a-MpIW__section",
});
